import{useSelector}from'react-redux';const useCookieConsent=()=>{return useSelector(state=>state.cookieConsent);};export default useCookieConsent;